import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const reportService = {
    getPastMonthSales,
    getRevenueSite,
    getMonth
};

function refineHeader() {
    let token = auth.getToken();
    if (token != "") {
      headerConfig.headerDatas["Authorization"] = "Bearer " + token;
    }
  }
  

function getPastMonthSales(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}report/past-month-sales-performance`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getRevenueSite(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}report/revenue-by-site`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMonth() {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas
    };
  
    return fetch(`${appConfig.api.url}report/month-year`, requestOptions)
      .then(handleResponse)
      .then(responseData => {
        return responseData;
      });
  }

  function handleResponse(response) {
    return response.text().then(text => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
        }
  
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }
  
      return data;
    });
  }


// WEBPACK FOOTER //
// ./src/app/services/API/reportService.js